import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { UiFieldset, InnerLoader } from 'src/ui';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { fetchMerchantTerminals } from 'src/payment/redux';

function TerminalsDisplayComponent({ account, user, terminals, loading, error, fetchMerchantTerminals }) {
  useEffect(() => {
    if (user.financialInstitutionId && account.id) {
      fetchMerchantTerminals({
        fi: user.financialInstitutionId,
        account: account.id,
      });
    }
  }, [user.financialInstitutionId, account.id, fetchMerchantTerminals]);

  if (loading) {
    return (
      <UiFieldset title="Terminals">
        <InnerLoader visible={true} />
      </UiFieldset>
    );
  }

  if (error) {
    return (
      <UiFieldset title="Terminals">
        <div className="notification is-warning">
          <p>{error}</p>
        </div>
      </UiFieldset>
    );
  }

  if (!terminals || terminals.length === 0) {
    return (
      <UiFieldset title="Terminals">
        <div className="notification is-info">
          <p>No terminals configured. Please contact support to set up your first terminal.</p>
        </div>
      </UiFieldset>
    );
  }

  const getStatusBadge = (isActive) => {
    if (!isActive) {
      return <span className="tag is-danger">Inactive</span>;
    }
    return <span className="tag is-success">Active</span>;
  };

  return (
    <UiFieldset title="Terminals">
      <div className="content">
        <p className="has-text-grey">
          Read-only view of configured POS terminals.
        </p>
      </div>

      {terminals.map((terminal, index) => (
        <div key={terminal.id} className="box" style={{ marginBottom: '1rem' }}>
          <Columns isMultiline>
            {/* Terminal Name & Status */}
            <Column isSize="2/3">
              <div className="field">
                <label className="label">Terminal Name</label>
                <div className="control">
                  <input 
                    className="input" 
                    type="text" 
                    value={terminal.name} 
                    readOnly 
                  />
                </div>
              </div>
            </Column>

            <Column isSize="1/3">
              <div className="field">
                <label className="label">Status</label>
                <div className="control">
                  {getStatusBadge(terminal.is_active)}
                </div>
              </div>
            </Column>

            {/* Terminal ID */}
            <Column isSize="1/2">
              <div className="field">
                <label className="label">Terminal ID</label>
                <div className="control">
                  <input 
                    className="input" 
                    type="text" 
                    value={terminal.terminal_id} 
                    readOnly 
                  />
                </div>
                <p className="help">Unique identifier for this terminal</p>
              </div>
            </Column>

            {/* Location */}
            <Column isSize="1/2">
              <div className="field">
                <label className="label">Location</label>
                <div className="control">
                  <input 
                    className="input" 
                    type="text" 
                    value={terminal.location || 'Not specified'} 
                    readOnly 
                  />
                </div>
                <p className="help">Physical location of terminal</p>
              </div>
            </Column>
          </Columns>
        </div>
      ))}
    </UiFieldset>
  );
}

TerminalsDisplayComponent.propTypes = {
  account: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  terminals: propTypes.array,
  loading: propTypes.bool.isRequired,
  error: propTypes.string,
  fetchMerchantTerminals: propTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  terminals: state.payment.terminals.data,
  loading: state.payment.terminals.loading,
  error: state.payment.terminals.error,
});

const mapDispatchToProps = {
  fetchMerchantTerminals,
};

export const TerminalsDisplay = connect(mapStateToProps, mapDispatchToProps)(TerminalsDisplayComponent);
